import React from 'react';
import { makeStyles, AppBar, Toolbar } from '@material-ui/core';
import { headerHeight, mobileHeaderHeight } from '../theme';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  title: {
    flexGrow: 1,
  },
  subhead: {
    color: '#424548',
    fontSize: 18,
    margin: 0,
    lineHeight: 1,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  header: {
    fontSize: 50,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
    },
    color: '#9D8453',
    margin: 0,
    lineHeight: 1,
    fontWeight: 300,
  },
  dna: {
    color: '#44244D',
    fontWeight: 700,
    fontStyle: 'bold',
  },
  logo: {
    height: 100,
    [theme.breakpoints.down('sm')]: {
      height: 50,
      left: -16,
    },
    position: 'relative',
    left: -27,
  },

  appBar: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/img/header_back.jpg)`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  toolbar: {
    height: headerHeight,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: mobileHeaderHeight,
      minHeight: mobileHeaderHeight,
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar elevation={0} position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            <h2 className={classes.header}>
              <span className={classes.ph}>PH</span>
              <span className={classes.dna}>DNA</span>
            </h2>
            <h1 className={classes.subhead}>Developing New Associates</h1>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
